import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ApplicationWizard } from '../../../components/wizard/applicationWizard';
import { renewRspForm } from '../../../FormDefinitions';
import { useFormContext } from '../formContext';

const RenewRspForm = (props: RouteComponentProps<{ applicationId: string, page?: string }>) => {
    const { match: { params: { applicationId } } } = props;
    const appId = (applicationId && parseInt(applicationId)) || 0;
    return (
        <useFormContext.Provider applicationId={appId} >
            <ApplicationWizard
                {...props}
                {...renewRspForm}
                applicationId={appId}
            />
        </useFormContext.Provider>
    );
};

export default RenewRspForm;
